import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {WebsocketService} from '../../engine/websocket.service';

@Injectable()
export class AdvertService {
  public advert$ = new Subject();

  constructor(private wsService: WebsocketService) {
    this.wsService.on('commercial').subscribe(() => this.showAdvert());
  }

  private showAdvert() {
    this.advert$.next(true);
  }
}
